var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 939,
    height: 938,
    viewBox: "0 0 939 938",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M469 930.5C723.879 930.5 930.5 723.879 930.5 469C930.5 214.121 723.879 7.5 469 7.5C214.121 7.5 7.5 214.121 7.5 469C7.5 723.879 214.121 930.5 469 930.5Z",
    stroke: "#325ba6",
    strokeWidth: 50
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314.188 688V251.636H486.347C519.444 251.636 547.64 257.957 570.935 270.599C594.23 283.099 611.986 300.5 624.202 322.801C636.56 344.96 642.739 370.528 642.739 399.506C642.739 428.483 636.489 454.051 623.989 476.21C611.489 498.369 593.378 515.628 569.657 527.986C546.077 540.344 517.526 546.523 484.003 546.523H374.273V472.588H469.088C486.844 472.588 501.475 469.534 512.98 463.426C524.628 457.176 533.293 448.582 538.975 437.645C544.799 426.565 547.711 413.852 547.711 399.506C547.711 385.017 544.799 372.375 538.975 361.58C533.293 350.642 524.628 342.19 512.98 336.224C501.333 330.116 486.56 327.062 468.662 327.062H406.446V688H314.188Z",
    fill: "#325ba6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.0459e449c5027249a22d35ae6e91ead3.svg";
export { ForwardRef as ReactComponent };